import { ContactFields as ContactFieldsFields } from '../../../ContactFields';

export const ContactFields: React.FC = () => (
  <ContactFieldsFields.Root>
    <ContactFieldsFields.Phone />
    <ContactFieldsFields.Email />
    <ContactFieldsFields.Mobile />
  </ContactFieldsFields.Root>
);
